import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import validate from 'validate.js';
import LegalDocuments from '../../components/purchase-legal-documents/legal-documents';
import Footer from '../../containers/footer.container';
import TopNavBar from '../top-nav-bar.container';

import { fetchPurchaseLegalDocuments, fetchPurchase } from '../../actions/index';
import { getCurrentPurchaseLegalDocuments } from '../../selectors/purchase-selector';


class PurchaseLegalDocumentsContainer extends Component {
  componentWillMount() {
    const slug = this.props.match.params.id;
    this.props.actions.fetchPurchase(slug)
      .then(() => this.props.actions.fetchPurchaseLegalDocuments(slug));
  }

  get isSingleUrl() {
    const { legalDocuments } = this.props;
    if (legalDocuments.length !== 1) return false;
    const isUrl = !validate({website: legalDocuments[0].content}, {website: {url: true}});
    return isUrl;
  }

  render() {
    const modifiers = 'rounded mt-5 px-5 py-5';
    if (this.isSingleUrl) {
      window.location = this.props.legalDocuments[0].content;
      return null;
    }

    return (
      <div>
        <TopNavBar />
        <div className={`container main-container legal-documents ${modifiers}`}>
          <LegalDocuments
            legalDocuments={this.props.legalDocuments}
          />
        </div>
        <Footer />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({
      fetchPurchaseLegalDocuments,
      fetchPurchase,
    }, dispatch),
  };
};

const mapStateToProps = (state) => {
  const legalDocuments = getCurrentPurchaseLegalDocuments(state);
  return {
    legalDocuments,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseLegalDocumentsContainer);



// WEBPACK FOOTER //
// ./src/desktop/containers/purchase-legal-documents/index.container.js